module.exports = __webpack_public_path__ + "img/onf.bdf35327.png";